import AccountNotifications from "./AccountNotifications";
export default AccountNotifications;
